import React from 'react';
import { FaGithub, FaLinkedin, FaOrcid } from 'react-icons/fa';

export default function Home({ pub }) {
  return (
    <div id="home" className="home-hero">
      <div className="intro">
        <img className="headshot" src={`${pub}/images/AustinHeadshotSmall.jpg`} alt="Austin Seamann headshot" />
        <h1>Austin Seamann</h1>
        <p>PhD candidate in <b>Quantitative Biomedicine</b> at Rutgers University.<br />
        I design proteins to solve problems in biotechnology and health.</p>
        <p>Previously, I earned my undergraduate and master&apos;s degrees in bioinformatics and biomedical informatics from the University of Nebraska at Omaha.</p>
        <div className="logos">
          <img src={`${pub}/images/rutgers-logo.png`} alt="Rutgers logo" />
          <img src={`${pub}/images/uno-logo.png`} alt="UNO logo" />
        </div>
        <div className="social-links">
          <a href="https://github.com/Aseamann" target="_blank" rel="noopener noreferrer">
            <FaGithub /> GitHub
          </a>
          <a href="https://www.linkedin.com/in/austin-seamann-ba199a257" target="_blank" rel="noopener noreferrer">
            <FaLinkedin /> LinkedIn
          </a>
          <a href="https://orcid.org/0000-0002-6824-0428" target="_blank" rel="noopener noreferrer">
            <FaOrcid /> ORCID
          </a>
        </div>
      </div>
    </div>
  );
}
